import { Badge, Button, Card, Divider, Grid, Icon, Input, Loader } from '@scuf/common';
import { LabelDescription } from 'components';
import { formatDate } from 'helpers';
import { RmaModelLite, statusOptions } from 'models';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { COMPANY_MANAGER, REPAIR_CENTER, RmaLite, companyDtoAtom, notificationAtom } from 'resources';
import useFetch from 'helpers/hooks/useFetch';
import { CompanyDTO } from 'models/userManager/addCustomer';
import { getColors } from 'helpers/getBadgeColors';
import { rmaStatusColors, rmaTypeColors } from 'models/repaircenter/detailsRma';
import requestFile from 'helpers/requestFile';
import useUser from 'helpers/hooks/useUser';
import '../../../../styles/repaircenter.scss';
//import { getCompanyByCnpj, getCompanyFromMicrosiga } from 'resources/api/usermanager_api/addCustomer';

const OrderAccordion: React.FC<any> = () => {
    const setNotification = useSetRecoilState(notificationAtom);
    const [rmaState, setRmaState] = useRecoilState<RmaModelLite>(RmaLite);
    const [isCredenciado, setIsCredenciado] = useState<boolean>();
    const [loadingAction, setLoadingAction] = useState<boolean>(false);
    const [changes, setChanges] = useState({
        Invoice: '',
        InvoiceValue: ''
    });
    const [company, setCompany] = useRecoilState<CompanyDTO>(companyDtoAtom);
    const [, getCompanyById, loadingCompany] = useFetch<{ id: number | undefined }, CompanyDTO>({
        url: COMPANY_MANAGER.getCompanyById,
        method: 'GET',
        onError: 'Error',
        redirectOnError: true
    });
    const { t } = useTranslation(['repaircenter', 'common', 'user']);
    const [, updateInvoice, loader] = useFetch<RmaModelLite>({
        url: REPAIR_CENTER.updateInvoice,
        method: 'POST',
        onError: 'Change',
        onSuccess: 'Change'
    });

    const { user: userDetails } = useUser();
    const isSuperAdmin = userDetails?.role === '1';
    const shippingObs = rmaState?.shipping?.observation;

    //CRIAR A isSuperAdmin

    useEffect(() => {
        setChanges({ Invoice: rmaState?.invoice, InvoiceValue: rmaState?.valorInvoice });
        if (rmaState?.companyId !== company?.id && rmaState?.companyId != null) {
            getCompanyInfo();
        }
    }, [rmaState]);

    useEffect(() => {
        if (company) {
            const isCredenciado = company.companyModules?.some(x => x.moduleId == 1);
            setIsCredenciado(isCredenciado);
        }
    }, [company]);

    const handleChanges = async (): Promise<void> => {
        await updateInvoice(
            { ...rmaState, invoice: changes.Invoice, valorInvoice: changes.InvoiceValue ? changes.InvoiceValue : '0' },
            _ => {
                setRmaState(old => ({ ...old, invoice: changes.Invoice, valorInvoice: changes.InvoiceValue }));
            }
        );
    };

    const validate = (): boolean => {
        return (
            (changes.Invoice !== rmaState?.invoice || changes.InvoiceValue !== rmaState?.valorInvoice) &&
            rmaState?.statusId !== 10
        );
    };

    function getListGbe() {
        if (isCredenciado) {
            const listGbe = company.companyLOB
                ?.filter(x => x?.lob?.gbe)
                .map(x => x.lob.gbe)
                .filter((gbe, index, self) => self.indexOf(gbe) === index);
            return listGbe;
        }
        return null;
    }

    const getCompanyInfo = async (): Promise<void> => {
        await getCompanyById({ id: rmaState?.companyId }, current => {
            setCompany(current.data!);
        });
    };

    const getStatusInfo = (statusId: number) => {
        const status = statusOptions.find(option => option.value === statusId);
        return status ? { name: status.text } : { name: 'Desconhecido' };
    };

    const handlePrint = async () => {
        setLoadingAction(true);
        try {
            await requestFile.print(REPAIR_CENTER.generatePdfFromRma, {
                method: 'GET',
                params: { id: rmaState?.id }
            });
            setLoadingAction(false);
        } catch {
            setNotification(old => ({ ...old, message: 'UploadError' }));
            setLoadingAction(false);
        }
    };

    const getTransportType = (): string => {
        const situation = rmaState?.shipping?.situation;

        switch (situation) {
            case '1':
                return 'Indefinido';
            case '2':
                return 'Logística Reversa Coleta - Coleta Domiciliar';
            case '3':
                return 'Logística Reversa - Postagem';
            case '4':
                return 'Transportadora';
            case '5':
                return 'Não se Aplica';
            case '6':
                return 'Em processamento';
            default:
                return '';
        }
    };

    return (
        <>
            {loadingCompany ? (
                <Loader text={t('common:actions.LoadingOrder')} />
            ) : (
                <Grid>
                    <h3>{t('common:translation.General')}</h3>
                    <Grid.Row>
                        <Grid.Column className="grid-column" width={3} mWidth={6} sWidth={12}>
                            <LabelDescription title={t('rma.order.RmaNumber')} value={rmaState?.id} />
                            <LabelDescription title={t('rma.order.RmaDate')} value={formatDate(rmaState?.createdAt)} />
                            <LabelDescription
                                title={t('common:translation.Status')}
                                value={
                                    <Badge color={getColors(rmaState?.statusId, rmaStatusColors)}>
                                        {getStatusInfo(rmaState?.statusId).name}
                                    </Badge>
                                }
                            />
                            <LabelDescription
                                title={t('common:translation.Modality')}
                                value={<Badge color={getColors(rmaState?.type?.id, rmaTypeColors)}>{rmaState?.type?.name}</Badge>}
                            />
                        </Grid.Column>
                        <Grid.Column className="grid-column" width={3} mWidth={6} sWidth={12}>
                            <LabelDescription title={t('rma.order.PostCode')} value={rmaState?.shipping?.code} />
                            <LabelDescription title={t('rma.order.Equipments')} value={rmaState?.rmaItems?.length ?? 0} />
                            <LabelDescription title={t('rma.order.Accessories')} value={rmaState?.acessorios} />
                            <LabelDescription title={t('repaircenter:rma.order.TransportType')} value={getTransportType()} />
                        </Grid.Column>
                        <Grid.Column className="grid-column" width={3} mWidth={6} sWidth={12}>
                            <LabelDescription
                                title={t('rma.order.ShipmentRequestResponse')}
                                value={rmaState?.shipping?.type.name}
                            />
                            <LabelDescription title={t('common:translation.CFOP')} value={rmaState?.cfop} />
                            <LabelDescription title={t('rma.order.Observations')} value={rmaState?.observacao} />
                        </Grid.Column>
                        <Grid.Column className="grid-column" width={3} mWidth={6} sWidth={12}>
                            <LabelDescription title={t('rma.order.InvoiceRemittance')}>
                                <Input
                                    disabled={rmaState?.statusId === 10}
                                    value={`${changes.Invoice}`}
                                    icon={<Icon name="edit" root="common" size="small" />}
                                    onChange={Invoice => setChanges({ ...changes, Invoice })}
                                />
                            </LabelDescription>
                            <LabelDescription title={t('rma.order.InvoiceValue')}>
                                <Input
                                    disabled={rmaState?.statusId === 10}
                                    value={changes?.InvoiceValue}
                                    icon={<Icon name="edit" root="common" size="small" />}
                                    onChange={InvoiceValue =>
                                        setChanges({
                                            ...changes,
                                            InvoiceValue
                                        })
                                    }
                                />
                            </LabelDescription>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            )}
            <div className="buttonsSearch">
                {validate() && (
                    <Button
                        size="small"
                        icon={<Icon name="save-as" root="common" />}
                        content={t('common:actions.Save')}
                        loading={loader}
                        onClick={handleChanges}
                    ></Button>
                )}
                <Button
                    icon={<Icon name="print" root="common" />}
                    iconPosition="left"
                    loading={loadingAction}
                    size="small"
                    onClick={() => handlePrint()}
                    content={t('common:actions.Print')}
                    type="primary"
                />
            </div>
            {isSuperAdmin && (
                <Grid>
                    <h3>{t('common:translation.Notices')}</h3>
                    <Grid.Row>
                        <Grid.Column className="grid-column" mWidth={6} sWidth={12}>
                            {shippingObs != null ? (
                                <Card style={{ backgroundColor: '#e6e6e6' }}>
                                    <Card.Content style={{ backgroundColor: '#e6e6e6' }}>
                                        {rmaState?.shipping?.observation}
                                    </Card.Content>
                                </Card>
                            ) : (
                                <Card style={{ backgroundColor: '#e6e6e6' }}>
                                    <Card.Content style={{ backgroundColor: '#e6e6e6', fontStyle: 'italic', color: '#969696' }}>
                                        {t('common:translation.NoComments')}
                                    </Card.Content>
                                </Card>
                            )}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column className="grid-column" width={4} mWidth={6} sWidth={12}>
                            <LabelDescription
                                title={t('repaircenter:rma.order.Shipping')}
                                value={rmaState?.shipping?.type?.name}
                            />
                        </Grid.Column>
                        <Grid.Column className="grid-column" width={4} mWidth={6} sWidth={12}>
                            <LabelDescription title={t('common:status.Situation')} value={rmaState?.shipping?.situation} />
                        </Grid.Column>
                        <Grid.Column className="grid-column" width={4} mWidth={6} sWidth={12}>
                            <LabelDescription title={t('rma.order.PostCode')} value={rmaState?.shipping?.code} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            )}
            <Divider></Divider>
            <Grid>
                <h3>{t('register:type.Company')}</h3>
                <Grid.Row>
                    <Grid.Column className="grid-column" width={isCredenciado ? 4 : 6} sWidth={12}>
                        <LabelDescription title={t('CNPJ')} value={rmaState?.cnpjCompany} />
                        <LabelDescription title={t('rma.order.Customer.InvoiceCNPJ')} value={rmaState?.cnpjNota} />
                        <LabelDescription
                            title={t('rma.order.Customer.StatusCNPJ')}
                            value={
                                rmaState?.statusCnpjCompany === 1
                                    ? t('common:status.Deactive')
                                    : rmaState?.statusCnpjCompany === 2
                                      ? t('common:status.Active')
                                      : t('common:status.NotValid')
                            }
                        />
                        <LabelDescription
                            title={t('rma.order.Customer.StatusInvoiceCNPJ')}
                            value={
                                rmaState?.statusCnpjNota === 1
                                    ? t('common:status.Deactive')
                                    : rmaState?.statusCnpjNota === 2
                                      ? t('common:status.Active')
                                      : t('common:status.NotValid')
                            }
                        />
                    </Grid.Column>
                    <Grid.Column className="grid-column" width={isCredenciado ? 4 : 6} sWidth={12}>
                        <LabelDescription title={t('user:company.Name')} value={company?.name} />
                        <LabelDescription title={t('repaircenter:translation.ResponsibleName')} value={rmaState?.package?.name} />
                        <LabelDescription
                            title={t('repaircenter:translation.ResponsibleEmail')}
                            value={company?.users?.find(x => x.ssoId === rmaState.ssoId)?.email}
                        />
                        <LabelDescription
                            title={t('repaircenter:translation.ResponsiblePhone')}
                            value={rmaState?.package?.phone}
                        />
                    </Grid.Column>
                    {isCredenciado && (
                        <Grid.Column className="grid-column" width={4} sWidth={12}>
                            <LabelDescription title={t('user:info.AccreditedClient')} />
                            <LabelDescription title={t('GBE')} value={getListGbe() ? getListGbe()?.join(' ') : 'Sem GBE'} />
                        </Grid.Column>
                    )}
                </Grid.Row>
            </Grid>
        </>
    );
};

export default OrderAccordion;
